import { capitalizeAll, formatDate } from '@btime/helpers'
import { compose, join, path, prop, propOr } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { shouldHideIndicators } from '../../../../utils/helpers/serviceOrder'
import Separator from '../../../../components/pdf/Separator'
import Image from '../../../../components/pdf/Image'
import Text from '../../../../components/pdf/Text'
import CountersBar from './CountersBar'

const ServiceOrderHeader = ({ serviceOrder, counters }) => {
  const { t } = useTranslation('serviceOrders')
  const title = serviceOrder.name || compose(path(['checklist', 'name']))(serviceOrder)
  const user = compose(capitalizeAll, path(['user', 'name']))(serviceOrder)
  const createdAt = compose(formatDate('DD/MM/YYYY HH:mm'), prop('insertedAt'))(serviceOrder)
  const executedAt = compose(formatDate('DD/MM/YYYY'), propOr('', 'startDate'))(serviceOrder)
  const isCompleted = serviceOrder?.status?.name === 'completed'
  const isAnonymousResponse = serviceOrder?.user === null && isCompleted
  const userToDisplay = isAnonymousResponse ? t('anonymousResponse') : user
  const subtitle = join(' | ', [executedAt, userToDisplay])
  let logo = false

  return (
    <div>
      <Separator weight={4} />
      {logo && <Image src={logo} ignoreFixedSize style={{ maxWidth: '10rem', maxHeight: '5rem' }} />}
      <Separator weight={4} />
      <Text size="h2" bold>
        {title}
      </Text>
      <Separator weight={1} />
      <Text size="h6">{subtitle}</Text>
      <Separator weight={4} />
      <Text size="small" bold>
        {t('pdf.createdAt', { date: createdAt })}
      </Text>

      <Separator weight={8} />
      <CountersBar counters={counters} />
      <Separator weight={4} />
    </div>
  )
}

export default ServiceOrderHeader
